import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const StoreSettingsContext = createContext({ shopEnabled: true, canShop: true, refresh: () => {} });

export const useStoreSettings = () => useContext(StoreSettingsContext);

export const StoreSettingsProvider = ({ children }) => {
  const { user } = useAuth();
  const [shopEnabled, setShopEnabled] = useState(true);

  const refresh = useCallback(() => {
    api.get("/settings/store").then(({ data }) => setShopEnabled(data.shop_enabled)).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // In vetrina l'admin può comunque usare il negozio per le prove (clienti bloccati)
  const canShop = shopEnabled || user?.role === "admin";

  return (
    <StoreSettingsContext.Provider value={{ shopEnabled, canShop, refresh }}>
      {children}
    </StoreSettingsContext.Provider>
  );
};
